// extracted by mini-css-extract-plugin
module.exports = {"HeaderNavLinks":"style_HeaderNavLinks__3MWeJ","active":"style_active__2P6ws"};